<template>
  <div class="row">
    <div class="col-12">
      <div class="card card-bottom-radius-8" style="background-color: #f9f9f9;">
        <div class="card-block">
          <form autocomplete="off" role="presentation">
            <div class="form-group row">
              <div class="col-md-12">
                <strong><i class="fas fa-money-check-alt text-default"></i> DESPESAS DIVERSOS </strong>
                <div v-if="HasData == true && this.obj != null && (this.obj.situacao === null || this.obj.situacao === 0)" class="edit-board d-none"><a href="javascript:void(0);" @click="onEdit"><i class="fas fa-edit"></i>&nbsp;<small>Editar</small></a></div>
              </div>
            </div>
            <div class="form-group row pt-2">
              <div class="col-md-4">
                <label>Folha:</label>
                <div class="input-group">
                  <strong>{{RequestNumber}}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <label>Data Solicitação:</label>
                <div class="input-group">
                  <strong>{{RequestDate}}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <label>Situação:</label>
                <div class="input-group">
                  <strong>{{Stage}}</strong>
                </div>
              </div>
            </div>
            <div class="form-group row pt-2">
              <div class="col-md-4">
                <label>Obra/Local:</label>
                <div class="input-group">
                  <strong>{{ObraRH}}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <label>Regional</label>
                <div class="input-group">
                  <strong>{{BranchName}}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <label>Responsável:</label>
                <div class="input-group">
                  <strong>{{Responsible}}</strong>
                </div>
              </div>
            </div>
            <div class="form-group row pt-2">
              <div class="col-md-4">
                <label>Solicitante:</label>
                <div class="input-group">
                  <strong>{{Requester}}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <label>Favorecido:</label>
                <div class="input-group">
                  <strong>{{Favored}}</strong>
                </div>
              </div>
              <div class="col-md-4">
                <div class="input-group pt-2">
                  <button type="button"
                          v-if="HasData == true && this.obj != null && (this.obj.situacao === null || this.obj.situacao === 0)"
                          class="btn btn-third btn-sm mr-1"
                          v-b-tooltip.hover
                          title="Enviar para Aprovação Coordenador Regional"
                          @click="onSectionApproval">
                    <i class="fas fa-play-circle"></i> Enviar para Aprovação
                  </button>
                  <b-dropdown variant="danger" no-caret
                          v-if="HasData == true && this.obj != null && (this.obj.situacao === null || this.obj.situacao === 0)">
                    <template slot="button-content">
                      <i class="fa fa-trash"></i> Excluir
                    </template>
                    <b-dropdown-header><strong>{{$lang.Common.ConfirmDelete}}</strong></b-dropdown-header>
                    <b-dropdown-item href="javascript:void(0);" v-on:click="onDelete">{{$lang.Common.Yes}}</b-dropdown-item>
                    <b-dropdown-item href="javascript:void(0);">{{$lang.Common.No}}</b-dropdown-item>
                  </b-dropdown>
                  <button type="button"
                          v-if="HasData === true && this.obj != null && (this.obj.situacao === 1 || this.obj.situacao === 2 || this.obj.situacao === 3)"
                          class="btn btn-success btn-sm mr-1"
                          v-b-tooltip.hover
                          title="Clique para Aprovar"
                          @click="onApproval">
                    <i class="fas fa-check-circle"></i> Aprovar
                  </button>
                  <button type="button"
                          v-if="HasData === true && this.obj != null && (this.obj.situacao === 1 || this.obj.situacao === 2 || this.obj.situacao === 3)"
                          class="btn btn-danger btn-sm mr-1"
                          v-b-tooltip.hover
                          title="Clique para Reprovar"
                          @click="onDisapproval">
                    <i class="fas fa-times-circle"></i> Reprovar
                  </button>
                  <button type="button"
                          v-if="HasData == true && this.obj != null && this.obj.situacao === 4"
                          class="btn btn-third btn-sm mr-1"
                          v-b-tooltip.hover
                          title="Clique para informar que o pagamento foi realizado!"
                          @click="onApproval">
                    <i class="fas fa-hand-holding-usd"></i> Pagamento Realizado
                  </button>
                  <button type="button"
                          v-if="HasData == true && this.obj != null && this.obj.situacao === 3"
                          class="btn btn-default btn-sm mr-1 d-none"
                          v-b-tooltip.hover
                          title="Clique para Gerar o Arquivo de Exportação"
                          @click="exportFile = !exportFile">
                    <i class="fas fa-file-export"></i> Exportar Arquivo
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group row pt-2">
              <div class="col-md-12">
                <label>
                  Observações:&nbsp;
                  <a v-if="showObservations == false" href="javascript:void(0);" @click="showObservations = true">
                    <i class="fas fa-plus-square"></i>
                  </a>
                  <a v-else href="javascript:void(0);" @click="showObservations = false">
                    <i class="fas fa-minus-square"></i>
                  </a>
                </label>
                <div v-show="showObservations" class="input-group">
                  <span class="edit-observations">{{Observations}}</span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Roles from '@/shared/utils/roles'
import PermisionMixin from '@/store/module/permission/mixin'
import Tools from '@/components/tools/Tools.js'

export default {
  name: 'MiscellaneousExpenseDetailsHeader',
  mixins: [ PermisionMixin ],
  data () {
    return {
      showObservations: false,
      roles: Roles,
      obj: null,
      exportFile: false,
      exportObj: {
        days: 0,
        eventFood: '',
        eventMeal: '',
        eventBreakfest: '',
        eventLunch: '',
        eventTransport: ''
      }
    }
  },
  computed: {
    HasData () {
      let result = false
      if (this.obj) {
        result = true
      }
      return result
    },
    RequestNumber () {
      let result = ''
      if (this.obj) {
        result = Tools.FormatCode(this.obj.folha)
      }
      return result
    },
    RequestDate () {
      let result = ''
      if (this.obj && this.obj.dataCriacao) {
        result = this.moment(this.obj.dataCriacao).format('DD/MM/YYYY HH:mm')
      }
      return result
    },
    Responsible: function () {
      let result = ''
      if (this.obj && this.obj.responsavel) {
        result = this.obj.responsavel.codigo + '-' + this.obj.responsavel.nome
      }
      return result
    },
    ObraRH: function () {
      let result = ''
      if (this.obj && this.obj.obraRH) {
        if (this.obj.obraRH.codigo) {
          result = this.obj.obraRH.codigo + '-'
        }
        result += this.obj.obraRH.nome
      }
      return result
    },
    BranchName: function () {
      let result = ''
      if (this.obj && this.obj.secaoRH) {
        if (this.obj.secaoRH.codigo) {
          result = this.obj.secaoRH.codigo + '-'
        }
        result += this.obj.secaoRH.nome
      }
      return result
    },
    Requester: function () {
      let result = ''
      if (this.obj && this.obj.nomeContaAcao) {
        result = this.obj.nomeContaAcao
      }
      return result
    },
    Favored: function () {
      let result = ''
      if (this.obj && this.obj.favorecido) {
        result = this.obj.favorecido.nome
      }
      return result
    },
    Observations: function () {
      let result = ''
      if (this.obj) {
        result = this.obj.observacao
      }
      return result
    },
    Stage: function () {
      let result = ''
      if (this.obj && this.obj.hasOwnProperty('situacao')) {
        switch (parseInt(this.obj.situacao)) {
          case 0: result = 'EM ELABORAÇÃO'
            break
          case 1: result = 'AGUARDANDO APROVAÇÃO MESTRE/ENGENHEIRO RESPONSÁVEL'
            break
          case 2: result = 'AGUARDANDO APROVAÇÃO RESPONSÁVEL REGIONAL'
            break
          case 3: result = 'AGUARDANDO APROVAÇÃO CONTROLADORIA'
            break
          case 4: result = 'APROVADO'
            break
          case 5: result = 'PAGAMENTO REALIZADO'
            break
          case -1: result = 'REPROVADO MESTRE/ENGENHEIRO RESPONSÁVEL'
            break
          case -2: result = 'REPROVADO RESPONSÁVEL REGIONAL'
            break
          case -3: result = 'REPROVADO CONTROLADORIA'
            break
          default: result = 'EM ELABORAÇÃO'
            break
        }
      }
      return result
    }
  },
  mounted () {
    this.showObservations = false
  },
  methods: {
    onAddBoard () {
      this.$emit('New')
    },
    onEdit () {
      if (this.HasData) {
        this.$emit('Edit', this.obj)
      }
    },
    onDelete () {
      this.$emit('Delete', this.obj)
    },
    onSectionApproval () {
      this.$emit('SectionApproval', this.obj)
    },
    onApproval () {
      this.$emit('Approval', this.obj)
    },
    onDisapproval () {
      this.$emit('Disapproval', this.obj)
    },
    onClone () {
      this.$emit('Clone', this.obj)
    },
    onExport () {
      this.$emit('Export', this.exportObj)
    }
  }
}
</script>
<style scoped>
.edit-board {
  display: block;
  position: absolute;
  text-align: right;
  width: 100%;
  right: 15px;
  top: -1px;
}
.edit-board i {
  font-size: 10px;
}
.edit-observations {
  background-color: #fff;
  padding: 10px;
  border: solid 1px #efefef;
  border-radius: 4px;
  width: 100%;
  min-height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/miscellaneous/details/components/headerdetails.vue